import {imsiQuery, imsiQueryPackage, imsiQueryCdr} from 'api/fastQueryOld';
import Cookies from 'js-cookie';

const fastQueryOld = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        //test
        imsiQuery({commit}, keyword) {
            return new Promise((resolve, reject) => {
                imsiQuery(keyword).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        imsiQueryPackage({commit}, imsi) {
            return new Promise((resolve, reject) => {
                imsiQueryPackage(imsi).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        imsiQueryCdr({commit}, imsi) {
            return new Promise((resolve, reject) => {
                imsiQueryCdr(imsi).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },



    }
};

export default fastQueryOld;



// WEBPACK FOOTER //
// ./src/store/modules/fastQueryOld.js